import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchCareerData = createAsyncThunk("career/fetchCareerData", async ({ lang = "en" }) => {
  console.log("Fetching career data with lang:", lang);
  try {
    const response = await axios.post(
      "https://milkys.bytesway.io/api/careers",
      { lang },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("API Response:", response.data);
    const transformedData = response.data.map((job) => ({
      jobId: job.id.toString(),
      JobName: job.job_title,
      JobLocation: job.location,
      JobType: job.job_type,
      JobDepartment: job.department,
      JobH1Data: job.description,
      JobH2Data: [{ JobH2Data1: job.responsibilities }],
      JobH4Data: Array.isArray(job.why_join)
        ? job.why_join.map((item) => ({
            JobH4Data1: item,
          }))
        : [],
    }));
    return transformedData;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
});

const CareerSlice = createSlice({
  name: "career",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCareerData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCareerData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload || [];
      })
      .addCase(fetchCareerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default CareerSlice.reducer;
